import { Component, Input, type OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { type FormGroupState, SetValueAction } from 'ngrx-forms';
import { AsyncPipe } from '@angular/common';
import { CommonUiSharedModule } from '@legacy/common-ui-shared';

import {
  BAC_QUESTIONNAIRE_ID,
  UsageQuestionnaireProps,
} from '../usage-questionnaire/usage-questionnaire.model';
import {
  SupplyType,
  type UsageQuestionnaireFormValues,
  getUsageFormControlIds,
} from '../usage-questionnaire/state/usage-questionnaire.reducer';
import { UsageQuestionnaireComponent } from '../usage-questionnaire/usage-questionnaire.component';

@Component({
  selector: 'wl-usage-questionnaire-modal',
  templateUrl: './usage-questionnaire-modal.component.html',
  standalone: true,
  imports: [AsyncPipe, UsageQuestionnaireComponent, CommonUiSharedModule],
})
export class UsageQuestionnaireModalComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) formState$!: Observable<
    FormGroupState<UsageQuestionnaireFormValues>
  >;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: UsageQuestionnaireProps;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() gasHidden = false;

  private readonly store = inject(Store);

  constructor(private readonly activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.gasHidden) {
      this.store.dispatch(
        new SetValueAction(
          getUsageFormControlIds(BAC_QUESTIONNAIRE_ID).supplyTypeControlId,
          SupplyType.E_ONLY
        )
      );
    }
  }

  public closeModal() {
    this.activeModal.close();
  }
}
